import React, { useEffect, useState, useRef } from "react";
import { Link, Route, useParams, useRouteMatch } from "react-router-dom";

import {
	Row,
	Avatar,
	Divider,
	Typography,
	Tag,
	Menu,
	Icon,
	Breadcrumb,
	Button,
	Col,
	Dropdown,
	Input,
	message,
	Modal,
	Table,
	Upload,
	Select,
	Tooltip,
	Switch,
	Checkbox,
	InputNumber,
	Radio,
} from "antd";
import Loader from "components/Loader/Loader";
import { fetchAllStoresApi, fetchCountryConfigurationApi, fetchCountryInformationApi, updateCountryConfigurationApi, updateCountryInformationApi, updateCountryStatusApi, updateFeatureListApi } from "utils/apiService";
import Level1Logo from "views/reffer-and-earn/images/Level1Logo.png";
import Level2Logo from "views/reffer-and-earn/images/Level2Logo.png";
import FAQSection from "./FaqSection";
import StoresTable from "views/stores-management/StoresTable";
import { Editor } from "@tinymce/tinymce-react";
import { countries } from "constants/CountryList";
import isDev from "server";
import axios from "axios";
const { Text } = Typography;
const { Option } = Select;

const CountryConfigurationDetails = (props) => {
	let { path } = useRouteMatch();
	const [activeCountryInfoTab, setActiveCountryInfoTab] = useState(path.includes("/countryInfo/:countryId") ? true : false);

	const { countryId, language } = props.match.params;
	const [countryInfo, setCountryInfo] = useState({});
	const [countrySpecificInfo, setCountrySpecificInfo] = useState({});
	const [loading, setLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(true);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [storeList, setStoreList] = useState({
		stores: [],
		pageNum: 1,
		pageSize: 10,
		total: 1,
	});
	const [currencyConversion, setCurrencyConversion] = useState({ points: 0, currency: 0 });

	const loadData = () => {
		fetchCountryConfigurationApi({
			requestData: { countryId },
			resCallback: () => {
				loading && setLoading(false);
			},
			res200Callback: (res) => {
				setCountryInfo(res.data);
				setCurrencyConversion({ points: res.data.currency_equivalent_in_points, currency: 1 });
			},
		});
	};

	const loadCountryInfoData = () => {
		fetchCountryInformationApi({
			requestData: { language: language },
			resCallback: () => {
				loading && setLoading(false);
			},
			res200Callback: (res) => {
				setCountrySpecificInfo(res.data);
			},
		});
	};

	const loadStores = () => {
		setTableLoading(true);
		fetchAllStoresApi({
			requestData: {
				countryId,
				// page: storeList.pageNum,
				// status: activeTab === "active" ? "active" : "archived",
			},
			resCallback: () => {
				setTableLoading(false);
			},
			res200Callback: (res) => {
				setStoreList({
					...storeList,
					stores: res.data.store_list,
				});
			},
		});
	};

	const updateCountryStatus = (status) => {
		updateCountryStatusApi({
			requestData: {
				country: countryId,
				country_status: status
			},
			resCallback: () => { },
			res200Callback: () => {
				loadData();
				message.success(`Country ${status ? "Activated" : "Deactivated"} successfully.`);
				// loadStores();
			},
		});
	};

	// tinymce editor image upload custom handler using axios
	const imageUploadHandler = async (blobInfo, success, failure) => {
		const formData = new FormData();
		formData.append("image", blobInfo.blob(), blobInfo.filename());
		const res = await axios.post(`${isDev()}/${countryId}/dashboard/upload-image/`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: `JWT ${localStorage.getItem("token")}`,
			},
		});
		success(res.data.url);
	};

	useEffect(() => {
		loadData();
		activeCountryInfoTab && loadCountryInfoData();
		loadStores();
	}, []);

	useEffect(() => {
		setCountryInfo({ ...countryInfo, currency_equivalent_in_points: currencyConversion.points / currencyConversion.currency });
	}, [currencyConversion.currency, currencyConversion.points]);

	return (
		<Row
			style={{
				width: "100%",
				padding: "40px 25px 70px",
				margin: "60px auto 20px",
				backgroundColor: "#FAFAFA",
			}}
			gutter={[12, 48]}>
			{loading ? (
				<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
					<Loader />
				</Row>
			) : (
				<>
					<Row type="flex" align="middle">
						<Text
							style={{
								color: "#181818",
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "24px",
								lineHeight: "39px",
							}}>
							{`${countries.find((country) => country.shortName === countryInfo.region_short_name)?.name || "India"} Configuration`}
						</Text>
					</Row>
					<Breadcrumb style={{ margin: "12px 0 24px" }} separator={<span style={{ color: "#747474" }}>{"<"}</span>}>
						<Breadcrumb.Item
							style={{
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
								fontWeight: "normal",
								fontSize: "14px",
								lineHeight: "22px",
								color: "#747474",
							}}>
							<Link to="/countries">Countries</Link>
						</Breadcrumb.Item>
						<Breadcrumb.Item
							style={{
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
								fontWeight: "normal",
								fontSize: "14px",
								lineHeight: "22px",
								color: "#464646",
							}}>
							{countries.find((country) => country.shortName === countryInfo.region_short_name)?.name || "India"}
						</Breadcrumb.Item>
					</Breadcrumb>
					{!activeCountryInfoTab &&
						<Row>
							<Text
								style={{
									color: "#181818",
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
									fontWeight: "bold",
									fontSize: "18px",
									lineHeight: "24px",
								}}>
								Country Details
							</Text>
							<Row
								gutter={[64, 24]}
								style={{
									padding: "16px 0px 12px 0px",
									width: "100%",
									// height: "276px",
									background: "#FFFFFF",
									border: "1px solid #E8E8E8",
									boxSizing: "border-box",
									borderRadius: "8px",
									margin: "8px 0px",
								}}>
								{/* <Row gutter={[64, 16]}> */}
								{/* <Col span={12} style={{}}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
										// fontWeight:"bold"
									}}>
									Date Format
								</Text>
								<Select
									disabled
									className="time-value-cohort-col-main-element"
									style={{ width: "100%", marginTop: "8px" }}
									placeholder="Select Date Format"
									value={countryInfo.date_format}
									onChange={(event) => {}}>
									<Option value="MM-DD-YY">MM-DD-YY</Option>
									<Option value="DD-MM-YY">DD-MM-YY</Option>
									<Option value="YY-MM-DD">YY-MM-DD</Option>
									<Option value="DD-MM-YYYY">DD-MM-YYYY</Option>
								</Select>
							</Col> */}
								<Col span={12}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										Country Code
									</Text>
									<Input
										disabled
										//   className="time-value-cohort-col-main-element"
										style={{
											width: "100%",
											marginTop: "8px",
										}}
										//   prefix={<Icon type="mail" theme="outlined" />}
										placeholder="Enter Country Code"
										value={countryInfo.country_code}
									// onChange={(event) => setCountryInfo({ ...countryInfo, minimum_sharing_amount: event.target.value })}
									/>
								</Col>
								<Col span={12} style={{}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										Time Zone
									</Text>
									<Select
										disabled
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "8px" }}
										placeholder="Select Time Zone"
										value={countryInfo.timezone}
										onChange={(event) => { }}>
										<Option value="Asia/Kolkata">Asia/Kolkata</Option>
										<Option value="Asia/Dubai">Asia/Dubai</Option>
										{/* <Option value="">Indian</Option> */}
									</Select>
								</Col>
								{/* </Row> */}
								{/* <Row gutter={64}> */}
								<Col span={12} style={{}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										Currency
									</Text>
									<Select
										disabled
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "8px" }}
										placeholder="Select Currency"
										value={countryInfo.currency}
										onChange={(event) => { }}>
										<Option value="INR">INR</Option>
										<Option value="AED">AED</Option>
										{/* <Option value="">INR</Option>
									<Option value="">INR</Option> */}
									</Select>
								</Col>
								{/* <Col span={12} style={{}}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
										// fontWeight:"bold"
									}}>
									Language Support
								</Text>
								<Checkbox.Group
									className="time-value-cohort-col-main-element"
									style={{ marginTop: "16px", width: "100%" }}
									options={[
										{ label: "English", value: "English" },
										{ label: "Hindi", value: "Hindi" },
										{ label: "Arabic", value: "Arabic" },

										{ label: "Malyalam", value: "Arabic" },
									]}
									defaultValue={["English"]}
									onChange={(checkedValues) => {}}
								/>
							</Col> */}
								<Col span={12} style={{}}>
									<Row gutter={[20, 16]}>
										<Col span={11}>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
													fontWeight: "bold",

													lineHeight: "22px",
													// fontWeight:"bold"
												}}>
												Points Value
											</Text>
											<Input
												className="time-value-cohort-col-main-element"
												style={{ width: "100%", marginTop: "8px" }}
												placeholder="Enter Points"
												value={currencyConversion.points}
												onChange={(event) => setCurrencyConversion({ ...currencyConversion, points: event.target.value })}
											/>
										</Col>

										<Col span={2} style={{ marginTop: "38px", textAlign: "center" }}>
											=
										</Col>
										<Col span={11}>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
													fontWeight: "bold",

													lineHeight: "22px",
													// fontWeight:"bold"
												}}>
												Currency
											</Text>
											<Input
												className="Currency-Input"
												style={{
													width: "100%",
													marginTop: "8px",
												}}
												placeholder="Enter Value"
												prefix={<Text style={{ marginRight: "10px" }}>{countryInfo.currency}</Text>}
												value={currencyConversion.currency}
												onChange={(event) => setCurrencyConversion({ ...currencyConversion, currency: event.target.value })}
											/>{" "}
										</Col>
									</Row>
								</Col>
								<Col span={12}>
									<Row gutter={[20, 16]}>
										<Col span={12}>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
													fontWeight: "bold",

													lineHeight: "22px",
													// fontWeight:"bold"
												}}>
												Decimal Points
											</Text>
											<InputNumber
												//   className="time-value-cohort-col-main-element"
												style={{
													width: "100%",
													height: "40px",
													// size: "large",
													marginTop: "8px",
													border: "1px solid #E8E8E8",
													background: "#FFFFFF",
													textAlign: "center"
												}}
												//   prefix={<Icon type="mail" theme="outlined" />}
												placeholder="Enter minimum voucher amount"
												value={countryInfo.decimal_points}
												onChange={(value) => setCountryInfo({ ...countryInfo, decimal_points: value })}
											/>
										</Col>
										<Col span={12}>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
													fontWeight: "bold",

													lineHeight: "22px",
													// fontWeight:"bold"
												}}>
												Specific Promotions
											</Text>
											<Radio.Group
												// className="time-value-cohort-col-main-element"
												style={{ width: "100%", marginTop: "8px", display: "flex", alignItems: "center" }}
												options={
													[
														{
															label: 'Enable',
															value: true,
														},
														{
															label: 'Disable',
															value: false,
														},
													]
												}
												onChange={(e) => { setCountryInfo({ ...countryInfo, specific_promotions: e.target.value }) }}
												value={countryInfo.specific_promotions}
												optionType="button"
												buttonStyle="solid"
											/>
										</Col>
									</Row>
								</Col>
								<Col span={12}>
									<Row gutter={[20, 16]}>
										<Col span={12}>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
													fontWeight: "bold",

													lineHeight: "22px",
													// fontWeight:"bold"
												}}>
												Voucher Access Time
											</Text>
											<InputNumber
												//   className="time-value-cohort-col-main-element"
												style={{
													width: "100%",
													height: "40px",
													// size: "large",
													marginTop: "8px",
													border: "1px solid #E8E8E8",
													background: "#FFFFFF",
													textAlign: "center"
												}}
												//   prefix={<Icon type="mail" theme="outlined" />}
												placeholder="Enter minimum voucher amount"
												value={countryInfo.voucher_access_time}
												onChange={(value) => setCountryInfo({ ...countryInfo, voucher_access_time: value })}
											/>
										</Col>
										<Col span={12}>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
													fontWeight: "bold",

													lineHeight: "22px",
													// fontWeight:"bold"
												}}>
												Voucher Point Decimal
											</Text>
											<InputNumber
												//   className="time-value-cohort-col-main-element"
												style={{
													width: "100%",
													height: "40px",
													// size: "large",
													marginTop: "8px",
													border: "1px solid #E8E8E8",
													background: "#FFFFFF",
													textAlign: "center"
												}}
												//   prefix={<Icon type="mail" theme="outlined" />}
												placeholder="Enter minimum voucher amount"
												value={countryInfo.voucher_point_decimal}
												onChange={(value) => setCountryInfo({ ...countryInfo, voucher_point_decimal: value })}
											/>
										</Col>
									</Row>
								</Col>
								<Col span={12}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											// lineHeight: "22px",
											fontWeight: "bold"
										}}>
										Minimum Voucher Amount
									</Text>
									<InputNumber
										//   className="time-value-cohort-col-main-element"
										style={{
											width: "100%",
											height: "40px",
											// size: "large",
											marginTop: "8px",
											border: "1px solid #E8E8E8",
											background: "#FFFFFF",
											textAlign: "center"
										}}
										//   prefix={<Icon type="mail" theme="outlined" />}
										placeholder="Enter minimum voucher amount"
										value={countryInfo.minimum_voucher_amount}
										onChange={(value) => setCountryInfo({ ...countryInfo, minimum_voucher_amount: value })}
									/>
								</Col>
								<Col span={12}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										SMS Vendor
									</Text>
									<Select
										disabled
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "8px" }}
										placeholder="Select SMS Vendor"
										value={countryInfo.sms_vendor}
										onChange={(event) => { }}>
										<Option value="mshastra">mshastra</Option>
										<Option value="alaris">alaris</Option>
										<Option value="test">test</Option>
										{/* <Option value="">INR</Option> */}
									</Select>
								</Col>
							</Row>
						</Row>
					}
					{/* <Row style={{ marginTop: "32px" }}>
						<Text
							style={{
								color: "#181818",
								// fontFamily: "Gotham",
								 fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "18px",
								lineHeight: "24px",
							}}>
							Share Points
						</Text>
						<Row
							gutter={[32, 16]}
							style={{
								padding: "16px 14px 24px 14px",
								width: "100%",
								// height: "276px",
								background: "#FFFFFF",
								border: "1px solid #E8E8E8",
								boxSizing: "border-box",
								borderRadius: "8px",
								margin: "8px 0px",
							}}>
							<Col span={12}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
										// fontWeight:"bold"
									}}>
									Minimum Share Points
								</Text>
								<Input
									//   className="time-value-cohort-col-main-element"
									style={{
										width: "100%",
										marginTop: "8px",
									}}
									//   prefix={<Icon type="mail" theme="outlined" />}
									placeholder="Enter minimum share points"
									value={countryInfo.minimum_sharing_amount}
									onChange={(event) => setCountryInfo({ ...countryInfo, minimum_sharing_amount: event.target.value })}
								/>
							</Col>
							<Col span={12}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
										// fontWeight:"bold"
									}}>
									Maximum Share Points
								</Text>
								<Input
									//   className="time-value-cohort-col-main-element"
									style={{
										width: "100%",
										marginTop: "8px",
									}}
									//   prefix={<Icon type="phone" />}
									placeholder="Enter maximum share points"
									value={countryInfo.maximum_sharing_amount}
									onChange={(event) => setCountryInfo({ ...countryInfo, maximum_sharing_amount: event.target.value })}
								/>
							</Col>
						</Row>
					</Row> */}

					{/* <Row style={{ marginTop: "32px" }}>
						<Text
							style={{
								color: "#181818",
								// fontFamily: "Gotham",
								fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "18px",
								lineHeight: "24px",
							}}>
							Voucher Redemption
						</Text>
						<Row
							gutter={[32, 16]}
							style={{
								padding: "16px 14px 24px 14px",
								width: "100%",
								// height: "276px",
								background: "#FFFFFF",
								border: "1px solid #E8E8E8",
								boxSizing: "border-box",
								borderRadius: "8px",
								margin: "8px 0px",
							}}>
							<Col span={12}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										// lineHeight: "22px",
										fontWeight:"bold"
									}}>
									Minimum Voucher Amount
								</Text>
								<InputNumber
									//   className="time-value-cohort-col-main-element"
									style={{
										width: "100%",
										height:"40px",
										// size: "large",
										marginTop: "8px",
										border: "1px solid #E8E8E8",
										background: "#FFFFFF",
										textAlign: "center"
									}}
									//   prefix={<Icon type="mail" theme="outlined" />}
									placeholder="Enter minimum voucher amount"
									value={countryInfo.minimum_voucher_amount}
									onChange={(value) => setCountryInfo({ ...countryInfo, minimum_voucher_amount: value })}
								/>
							</Col>
						</Row>
					</Row> */}

					{/* <Row style={{ marginTop: "32px" }}>
						<Text
							style={{
								color: "#181818",
								fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "18px",
								lineHeight: "24px",
							}}>
							Refer and Earn
						</Text>
						<Row
							gutter={[32, 16]}
							style={{
								padding: "16px 14px 24px 14px",
								width: "100%",
								background: "#FFFFFF",
								border: "1px solid #E8E8E8",
								boxSizing: "border-box",
								borderRadius: "8px",
								margin: "8px 0px",
							}}>
							<Col span={12}>
								<Avatar size={20} src={Level1Logo} style={{ marginRight: "4px" }} />
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
									}}>
									Level 1 Referral
								</Text>

								<Text
									style={{
										lineHeight: "18px",
										fontSize: "12px",
										fontWeight: "300",
										marginLeft: "4px",
										position: "absolute",
										top: "12px",
									}}>
									Downloads
								</Text>
								<Input
									style={{
										width: "100%",
										marginTop: "8px",
									}}
									placeholder="Enter the Level 1 Referral amount"
									onChange={(event) => {}}
								/>
							</Col>
							<Col span={12}>
								<Avatar size={20} src={Level2Logo} style={{ marginRight: "4px" }} />
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
									}}>
									Level 2 Referral
								</Text>
								<Text
									style={{
										lineHeight: "18px",
										fontSize: "12px",
										fontWeight: "300",
										marginLeft: "4px",

										position: "absolute",
										top: "12px",
									}}>
									First Purchase
								</Text>
								<Input
									style={{
										width: "100%",
										marginTop: "8px",
									}}
									placeholder="Enter the Level 2 Referral amount"
									onChange={(event) => {}}
								/>
							</Col>
						</Row>
					</Row> */}

					{/* <Row style={{ marginTop: "32px" }}>
						<Text
							style={{
								color: "#181818",
								//fontFamily: "Gotham",
								 fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "18px",
								lineHeight: "24px",
							}}>
							SMS Vendor Details
						</Text>
						<Row
							gutter={[32, 16]}
							style={{
								padding: "16px 14px 24px 14px",
								width: "100%",
								// height: "276px",
								background: "#FFFFFF",
								border: "1px solid #E8E8E8",
								boxSizing: "border-box",
								borderRadius: "8px",
								margin: "8px 0px",
							}}>
							<Col span={12}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
										// fontWeight:"bold"
									}}>
									SMS Vendor
								</Text>
								<Select
									disabled
									className="time-value-cohort-col-main-element"
									style={{ width: "100%", marginTop: "8px" }}
									placeholder="Select SMS Vendor"
									value={countryInfo.sms_vendor}
									onChange={(event) => {}}>
									<Option value="mshastra">mshastra</Option>
									<Option value="alaris">alaris</Option>
									<Option value="test">test</Option>
								</Select>
							</Col>
							<Col span={12}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",

										lineHeight: "22px",
										// fontWeight:"bold"
									}}>
									SMS Vendor Key
								</Text>
								<Input
									disabled={true}
									//   className="time-value-cohort-col-main-element"
									style={{
										width: "100%",
										marginTop: "8px",
									}}
									//   prefix={<Icon type="phone" />}
									placeholder="Enter SMS Vendor Key"
									onChange={(event) => {}}
								/>
							</Col>
						</Row>
					</Row> */}
					{activeCountryInfoTab &&
						<Row style={{ marginTop: "32px" }}>
							<Text
								style={{
									color: "#181818",
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
									fontWeight: "bold",
									fontSize: "18px",
									lineHeight: "24px",
								}}>
								Contact Information
							</Text>
							<Row
								gutter={[32, 16]}
								style={{
									padding: "16px 14px 24px 14px",
									width: "100%",
									// height: "276px",
									background: "#FFFFFF",
									border: "1px solid #E8E8E8",
									boxSizing: "border-box",
									borderRadius: "8px",
									margin: "8px 0px",
								}}>
								<Col span={24}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										Address
									</Text>
									<Input
										//   className="time-value-cohort-col-main-element"
										style={{
											width: "100%",
											marginTop: "8px",
										}}
										value={countrySpecificInfo.contact_info?.address}
										placeholder="Enter address"
										onChange={(event) => setCountrySpecificInfo({ ...countrySpecificInfo, contact_info: { ...countrySpecificInfo.contact_info, address: event.target.value } })}
									/>
								</Col>

								<Col span={12}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										Email ID
									</Text>
									<Input
										//   className="time-value-cohort-col-main-element"
										style={{
											width: "100%",
											marginTop: "8px",
										}}
										prefix={<Icon type="mail" theme="outlined" />}
										placeholder="Enter Email ID"
										value={countrySpecificInfo.contact_info?.email}
										onChange={(event) => setCountrySpecificInfo({ ...countrySpecificInfo, contact_info: { ...countrySpecificInfo.contact_info, email: event.target.value } })}
									/>
								</Col>
								<Col span={12}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										Phone Number
									</Text>
									<Input
										//   className="time-value-cohort-col-main-element"
										style={{
											width: "100%",
											marginTop: "8px",
										}}
										prefix={<Icon type="phone" />}
										placeholder="Enter Phone Number"
										value={countrySpecificInfo.contact_info?.phone_number}
										onChange={(event) =>
											setCountrySpecificInfo({ ...countrySpecificInfo, contact_info: { ...countrySpecificInfo.contact_info, phone_number: event.target.value } })
										}
									/>
								</Col>
							</Row>
						</Row>
					}
					<Row style={{ marginTop: "32px" }}>
						{activeCountryInfoTab &&
							<Text
								style={{
									color: "#181818",
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
									fontWeight: "bold",
									fontSize: "18px",
									lineHeight: "24px",
								}}>
								Additional Details
							</Text>
						}
						{activeCountryInfoTab &&
							<Row
								gutter={[16, 24]}
								style={{
									padding: "16px 24px 24px 24px",
									width: "100%",
									background: "#FFFFFF",
									border: "1px solid #E8E8E8",
									boxSizing: "border-box",
									borderRadius: "8px",
									margin: "8px 0px",
								}}>
								<Col span={24}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										About us
									</Text>
									<div
										style={{
											width: "100%",
											marginTop: "8px",
										}}>
										<Editor
										    apiKey='5uv78fphj9sndnha6xh30qanrvek9n49j9z9bcykz2ki9i06'
											style={{
												border: "1px solid #D9D9D9",
												borderRadius: "4px",
											}}
											value={countrySpecificInfo.about_us}
											onEditorChange={(newValue, editor) => setCountrySpecificInfo({ ...countrySpecificInfo, about_us: newValue })}
											init={{
												height: 200,
												menubar: true,
												image_uploadtab: true,
												file_picker_types: "image",
												images_upload_handler: imageUploadHandler,
												plugins: [
													"advlist autolink lists link image charmap print preview anchor",
													"searchreplace visualblocks code fullscreen",
													"insertdatetime media table paste code help wordcount",
												],
												toolbar:
													"undo redo | formatselect  | bold italic | alignleft aligncenter " +
													"alignright alignjustify | bullist numlist outdent indent | " +
													"removeformat | help",
												content_style: "body { font-family: Helvetica }",
											}}
										/>
									</div>
								</Col>
								<Col span={24}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "22px",
											// fontWeight:"bold"
										}}>
										Privacy Policy
									</Text>
									<div
										style={{
											width: "100%",
											marginTop: "8px",
										}}>
										<Editor
											style={{
												border: "1px solid #D9D9D9",
												borderRadius: "4px",
											}}
											value={countrySpecificInfo.privacy_policy}
											onEditorChange={(newValue, editor) => setCountrySpecificInfo({ ...countrySpecificInfo, privacy_policy: newValue })}
											init={{
												height: 200,
												menubar: true,
												image_uploadtab: true,
												file_picker_types: "image",
												images_upload_handler: imageUploadHandler,
												// images_upload_credentials: true,
												plugins: [
													"advlist autolink lists link image charmap print preview anchor",
													"searchreplace visualblocks code fullscreen",
													"insertdatetime media table paste code help wordcount",
												],
												toolbar:
													"undo redo | formatselect  | bold italic | alignleft aligncenter " +
													"alignright alignjustify | bullist numlist outdent indent | " +
													"removeformat | help",
												content_style: "body { font-family: Helvetica }",
											}}
										/>
									</div>
								</Col>
							</Row>
						}
						{activeCountryInfoTab &&
							<Row style={{ marginTop: "32px" }}>
								<Text
									style={{
										color: "#181818",
									/*fontFamily: "Gotham",*/ fontStyle: "normal",
										fontWeight: "bold",
										fontSize: "18px",
										lineHeight: "24px",
									}}>
									FAQs
								</Text>
								<FAQSection
									faqList={countrySpecificInfo.faq ? countrySpecificInfo.faq : []}
									setFaqList={(faq) => {
										setCountrySpecificInfo({ ...countrySpecificInfo, faq });
									}}
									imageUploadHandler={imageUploadHandler}
								/>
							</Row>
						}

						<Row style={{ marginTop: "32px" }}>
							{/* <div style={{ display: "flex", justifyContent: "space-between" }}>
								<Text
									style={{
										color: "#181818",
										fontStyle: "normal",
										fontWeight: "bold",
										fontSize: "18px",
										lineHeight: "24px",
									}}>
									Stores
								</Text>
								<Text
									style={{
										color: "#464646",
										fontStyle: "normal",
										fontSize: "16px",
										lineHeight: "24px",
									}}>
									Note : <span style={{ color: "#747474" }}> Contact admin to add a new store</span>
								</Text>
							</div> */}
							{/* <StoresTable data={{ ...storeList, stores: storeList.stores.filter((store) => store.is_enabled) }} viewOnly={true}></StoresTable> */}

							<div style={{ marginTop: "16px", textAlign: "right" }}>
								<Button
									size="large"
									style={{
										height: "40px",
										borderRadius: "5px",
										border: "none",
										backgroundColor: "#fec708",
										color: "#FFFFFF",
									}}
									onClick={() => {
										// delete countryInfo["uuid","currency","timezone","date_modified","sms_vendor"];
										activeCountryInfoTab && updateCountryInformationApi({
											requestData: {
												...countrySpecificInfo,
											},
											res200Callback: () => {
												message.success("Country Information updated successfully.");
											},
											resErrorCallback: () => {
												message.error("Error while updating country configuration!");
											},
										});
										!activeCountryInfoTab && updateCountryConfigurationApi({
											requestData: {
												countryId,
												...countryInfo,
											},
											res200Callback: () => {
												message.success("Country configuration updated successfully.");
											},
											resErrorCallback: () => {
												message.error("Error while updating country configuration!");
											},
										});
										!activeCountryInfoTab && updateFeatureListApi({
											requestData: {
												countryId,
												SHARE_POINTS: {
													config: {
														MINIMUM_AMOUNT: countryInfo.minimum_sharing_amount,
														MAXIMUM_AMOUNT: countryInfo.maximum_sharing_amount,
													},
												},
												// REFER_AND_EARN: {
												// 	config: {
												// 		GIVE_REWARD: "boolean",
												// 		REWARD_LEVEL_1: "int",
												// 		REWARD_LEVEL_2: "int",
												// 	},
												// },
											},
											res200Callback: () => {
												message.success("Share points limits updated successfully.");
											},
											resErrorCallback: () => {
												message.error("Error while updating share points limits!");
											},
										});
									}}>
									Save and Publish
								</Button>
							</div>
						</Row>
						{!activeCountryInfoTab &&
							<Row
								gutter={[32, 16]}
								style={{
									padding: `${false ? "24px" : "24px 32px 24px 24px"}`,
									width: "100%",
									// height: "276px",
									background: "#FFFFFF",
									border: "1px solid #E8E8E8",
									boxSizing: "border-box",
									borderRadius: "8px",
									margin: "32px 0px 32px 0px ",
								}}>
								<Col span={21} style={{ display: "flex", flexDirection: "column" }}>
									<Text
										style={{
											fontSize: "18px",
											color: "#181818",
											fontWeight: "bold",

											lineHeight: "24px",
											// fontWeight:"bold"
										}}>
										Change country availability status
									</Text>

									{countryInfo.is_active ? (
										<Text
											style={{
												fontSize: "16px",
												fontWeight: "400",
												marginTop: "8px",
												lineHeight: "24px",
											}}>
											All users in this country will lose access to the app if status is changed to
											{<span style={{ fontWeight: "bold" }}> Deactivate</span>}
										</Text>
									) : (
										<Text
											style={{
												fontSize: "16px",
												fontWeight: "400",
												marginTop: "8px",
												lineHeight: "24px",
											}}>
											By changing the status to
											{<span style={{ fontWeight: "bold" }}> Activate</span>}, all users in this country will be able to use the app.
										</Text>
									)}
								</Col>
								<Col span={2}>
									<Button
										onClick={() => {
											// setCountryInfo({ ...countryInfo, is_active: !countryInfo.is_active })
											updateCountryStatus(!countryInfo.is_active)
										}}
										style={{
											height: "40px",
											width: "auto",
											textAlign: "center",
											padding: "8px 16px 8px 16px",
											borderRadius: "4px",
											background: "#FFFFFF",
											border: "1px solid #D9D9D9",
										}}>
										<Text
											style={{
												fontSize: "16px",
												color: "#F5222D",
												//   fontWeight: "bold",

												lineHeight: "24px",
											}}>
											{!countryInfo.is_active ? "Activate" : "Deactivate"}
										</Text>
									</Button>
								</Col>
							</Row>
						}
					</Row>
				</>
			)}
		</Row>
	);
};
export default CountryConfigurationDetails;
